/** DOM-free rules for moving focus after client-side navigation (see RouteFocus.tsx). */

interface RouteLocation {
  pathname: string;
}

/**
 * Only a new page moves focus: not the first render (`previous` is null), nor a
 * change of only the search (list filters) or hash (in-page links).
 */
export const shouldMoveFocus = (previous: RouteLocation | null, next: RouteLocation): boolean =>
  previous !== null && previous.pathname !== next.pathname;

/**
 * True while the new page has not placed focus itself: focus is still where the
 * navigation started (the clicked link), or fell back to the body or nowhere
 * because that element was removed.
 */
export const focusUntouched = <T>(active: T | null, startedOn: T | null, body: T | null): boolean =>
  active === null || active === body || active === startedOn;
